// #TODO 30-04-2018_FG Terminer les interfaces

// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, BehaviorSubject } from 'rxjs';

// Afidium
import { ApiService } from 'libraries/service/api/api.service';
import { SharedData } from '../../shared-data';
import { ISelectedQuotation } from '../../models/quotation';
import { ICurrency } from '../../../service/resources/model/search/ICurrency';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import {
    IPostHotelBookingsCreateRequest,
    IPostHotelBookingsCreateResponse
} from 'libraries/service/resources/hotel/IPostHotelBookingsCreate';
import { HotelResourceService } from 'libraries/service/resources/hotel/hotelResource.service';
import { IGetPropertyResponse } from 'libraries/service/resources/hotel/ISearchResponse';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class QuotationService extends ApiService {

    public bookingLabels: ILabels = {
        error: Yii.t('wui-shared-js', "Le statut de l'offre ne permet pas la réservation, ou la réservation de l'offre avec frais d'annulations est impossible car le dossier n'a pas été accepté par le client."),
        info: Yii.t('wui-shared-js', 'Veuillez réessayer lorsque le statut du dossier le permettra OU choisissez une offre annulable sans frais.')
    };
    public selectedQuotation: BehaviorSubject<ISelectedQuotation> = new BehaviorSubject(null);

    private _request: IPostHotelBookingsCreateRequest;

    constructor(
        public http: HttpClient,
        private readonly sharedData: SharedData,
        private readonly hotelResourceService: HotelResourceService,
    ) {
        super(http);
    }

    public get request(): IPostHotelBookingsCreateRequest {
        return this._request;
    }

    public set request(requestValue: IPostHotelBookingsCreateRequest) {
        this._request = requestValue;
    }

    public setQuotation(quotation): void {
        this.sharedData.setData('quotation', quotation);
    }

    public getSelectedQuotation(): Observable<ISelectedQuotation> {
        return this.selectedQuotation.asObservable();
    }

    public setSelectedQuotation(selectedQuotation: ISelectedQuotation): void {
        const udpdatedSelectedQuotation: ISelectedQuotation = this.selectedQuotation.getValue();

        this.selectedQuotation.next({
            ...udpdatedSelectedQuotation,
            ...selectedQuotation
        });
    }

    public getCurrentSelectedQuotation(): ISelectedQuotation {
        return this.selectedQuotation.getValue();
    }

    public getPrice(price: string | { [key: string]: number }, currency: ICurrency): number {
        if (currency && price) {
            const priceFound: number = price[currency.code] || price;
            return priceFound / Math.pow(10, currency.decimals);
        }

        console.warn('Les paramètres price && currency sont nécessaires', price, currency);
        return null;
    }

    public create(request: IPostHotelBookingsCreateRequest): Observable<IPostHotelBookingsCreateResponse> {
        return this.hotelResourceService.book(request);
    }

    public getQuotationById(quotationId: string): Observable<IGetPropertyResponse> {
        return this.hotelResourceService.getQuotationById(quotationId);
    }
}
